import React from 'react';
import Components from '../../../components';

const headerMap = {
    "index": {label: "Sl.No.",},
    "username": {label: "Id",},
    "name": {label: "Name",},
    "address": {label: "Address",},
    "createdAt": {label: "Created At",}
}



const StudentList = ({list}) => {
    
    const headers = ["index", "username", "name", "address", "createdAt"]

    return <div className="student-list">
        <Components.data.Table headerMap={headerMap} headers={headers} data={list}/>
    </div>
}

export default StudentList